import { Button } from '@vapor/material'
import { styled } from '@mui/material/styles'

export const HicIconButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    minWidth: '40px !important',
    padding: theme.spacing(0.5),
  },
  '& .MuiButton-endIcon': {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      paggingLeft: theme.spacing(0.5),
      marginLeft: theme.spacing(0),
    },
  },
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      paggingRight: theme.spacing(0.5),
      marginRight: theme.spacing(0),
    },
  },
})) as typeof Button
